import React from "react"
import { RegisterOptions, UseFormRegisterReturn } from "react-hook-form"

type RenderProps = {
  id?: string
  type: string
  name: string
  required?: boolean
  className?: string
  placeholder?: string
  accept?: string
  onChange: (value: FileList | null) => void
  register?: (name: string, options?: RegisterOptions) => UseFormRegisterReturn
  onFocus?: (value: string) => void
}

const FileInput: React.FC<RenderProps> = ({
  id,
  name,
  required,
  className = "",
  placeholder = "",
  accept,
  onChange,
  register,
  onFocus,
}) => {
  const registration = register ? register(name, { required }) : undefined

  return (
    <input
      id={id}
      {...(registration || {})}
      type="file"
      name={name}
      placeholder={placeholder}
      required={required}
      onChange={event => {
        registration?.onChange(event)
        onChange(event.target.files)
      }}
      className={className}
      onFocus={event => {
        onFocus && onFocus(event.target.id)
      }}
      accept={accept}
    />
  )
}

export default FileInput
